"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _intlTs = require("@gogame/intl-ts");
var _Icon = require("@gogame/ui/Icon");
var _IconButton = _interopRequireDefault(require("@gogame/ui/IconButton"));
var _Select = require("@gogame/ui/Select");
var _Stack = _interopRequireDefault(require("@gogame/ui/Stack"));
var _Typography = _interopRequireDefault(require("@gogame/ui/Typography"));
var _styles = require("@gogame/ui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_LIMITS = [{
  name: '25',
  id: 25
}, {
  name: '50',
  id: 50
}, {
  name: '100',
  id: 100
}];
var Pagination = function Pagination(props) {
  var handlePrevPage = function handlePrevPage() {
    var offset = props.offset,
      limit = props.limit;
    props.onChange({
      offset: Math.max(offset - limit, 0),
      limit: limit
    });
  };
  var handleNextPage = function handleNextPage() {
    var offset = props.offset,
      limit = props.limit;
    props.onChange({
      offset: offset + limit,
      limit: limit
    });
  };
  var handlePageChange = function handlePageChange(_e, offset) {
    var limit = props.limit;
    props.onChange({
      offset: offset,
      limit: limit
    });
  };
  var handleLimitChange = function handleLimitChange(_e, value) {
    props.onChange({
      limit: value,
      offset: 0
    });
  };
  var offset = props.offset,
    _props$limit = props.limit,
    limit = _props$limit === void 0 ? 1 : _props$limit,
    _props$count = props.count,
    count = _props$count === void 0 ? 0 : _props$count,
    _props$limits = props.limits,
    limits = _props$limits === void 0 ? DEFAULT_LIMITS : _props$limits;
  var totalPerLimit = Math.min(offset + limit, count);
  var totalPages = Math.ceil(count / limit);
  var pages = Array(totalPages).fill(1).map(function (_, i) {
    return {
      id: i * limit,
      name: "".concat(i + 1)
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    direction: 'row',
    alignItems: 'center',
    spacing: 2,
    "data-cy": 'pagination',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], {
      variant: 'body2',
      sx: {
        whiteSpace: 'nowrap'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_intlTs.NumberValueFormatter.Decimal, {
        value: count,
        "data-cy": 'countRecords'
      }), ' ', "records"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      direction: 'row',
      alignItems: 'center',
      spacing: 1,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        variant: 'body2',
        children: "Show:"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        value: limit,
        variant: 'outlined',
        onChange: handleLimitChange,
        options: limits,
        dense: true,
        withFilter: false,
        "data-cy": 'showSelect'
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      direction: 'row',
      alignItems: 'center',
      spacing: 1,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        variant: 'body2',
        sx: {
          whiteSpace: 'nowrap'
        },
        children: "current page:"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        value: offset,
        variant: 'outlined',
        onChange: handlePageChange,
        options: pages,
        dense: true,
        withFilter: false,
        "data-cy": 'currentPageSelect'
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], {
        variant: 'body2',
        sx: {
          whiteSpace: 'nowrap'
        },
        children: ["\xA0of ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_intlTs.NumberValueFormatter.Decimal, {
          value: totalPages
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      direction: 'row',
      alignItems: 'center',
      spacing: 1,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ChevronLeftIcon, {}),
        onClick: handlePrevPage,
        disabled: offset <= 0,
        "data-cy": 'prevPage',
        tooltip: 'Previous page'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ChevronRightIcon, {}),
        onClick: handleNextPage,
        disabled: totalPerLimit >= count,
        "data-cy": 'nextPage',
        tooltip: 'Next page'
      })]
    })]
  });
};
var _default = exports["default"] = Pagination;